// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'; import './autoload/_fontawesome.js'; import './autoload/_swiper.js'

import 'slick-carousel/slick/slick.min';
import 'jquery.flipster/dist/jquery.flipster.min';
import 'select2/dist/js/select2.min.js';

import Lightbox from 'bs5-lightbox';
window.Lightbox = Lightbox;

import SimpleBar from 'simplebar';

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';



// import then needed Font Awesome functionality
import { library, dom } from '@fortawesome/fontawesome-svg-core';
// import the Facebook and Twitter icons
import { faFacebookF, faTwitter, faInstagram, faVimeoV, faSoundcloud, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { faAngleDoubleDown, faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import { faCalendarAlt, faUser, faCommentDots} from '@fortawesome/free-regular-svg-icons';


library.add(faAngleDoubleDown, faCommentDots, faFacebookF, faTwitter, faLinkedinIn, faSearch, faTimes, faVimeoV, faInstagram, faSoundcloud, faUser, faCalendarAlt);

dom.watch();

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

/** VanilaJS adding listener to navigation to add style when navbar is affixed */
// document.addEventListener('DOMContentLoaded', () => {
//   if (window.scrollY >= 1) {
//     document.getElementsByTagName('body')[0].classList.add('affixed')
//   } else {
//     document.getElementsByTagName('body')[0].classList.remove('affixed')
//   }

//   window.addEventListener('scroll', () => {
//     if (window.scrollY >= 1) {
//       document.getElementsByTagName('body')[0].classList.add('affixed')
//     } else {
//       document.getElementsByTagName('body')[0].classList.remove('affixed')
//     }
//   })
// })

// export {SimpleBar};

// global.SimpleBar = require('simplebar/dist/simplebar');
// //global.SimpleBar = SimpleBar;


global.$ = global.jQuery = require('jquery');

// $('.simplebar').each(function() { 
//   new SimpleBar($(this), { autoHide: false })
// });

//$('.simplebar').each( new SimpleBar());
$('.simplebar').each(function(){ new SimpleBar(this,{
  autoHide: false,
})});

// $(document).on('click', 'a[data-toggle="lightbox"]', function(event) {

//   event.preventDefault();
//   const el = $(this);
//   const lightbox = new Lightbox(el);
//   lightbox.show();
// });
//  new SimpleBar(document.getElementById('simplebar'),{ 
//   autoHide: false,
//   // forceVisible: true,
// });
$(window).resize(function(){

});
// Load Events
jQuery(document).ready(() => routes.loadEvents());





// WEBPACK FOOTER //
// ./scripts/main.js